import { useState, useEffect } from "react";
import ReconciliationLogin from "./ReconciliationLogin";
import ReconciliationMain from "./ReconciliationMain";

export default function ReconciliationApp() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedToken = localStorage.getItem("recon_token");
    const savedUser  = localStorage.getItem("recon_user");
    if (savedToken && savedUser) {
      setToken(savedToken);
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  function handleLogin(token, user) {
    localStorage.setItem("recon_token", token);
    localStorage.setItem("recon_user", JSON.stringify(user));
    setToken(token);
    setUser(user);
  }

  function handleLogout() {
    localStorage.removeItem("recon_token");
    localStorage.removeItem("recon_user");
    setToken(null);
    setUser(null);
  }

  if (loading) return (
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",
      height:"100vh",background:"#0d1117",color:"#3b82f6",fontSize:14,letterSpacing:"0.15em"}}>
      THOTH AI LOADING...
    </div>
  );

  if (!user) return <ReconciliationLogin onLogin={handleLogin} />;

  return <ReconciliationMain user={user} token={token} onLogout={handleLogout} />;
}
